<template>
  <div class="processConfig column-me">
    <div class="card-div">
      <div class="item-div" v-for="(item,index) in tableData" :key="index">
        <div class="row-me row-center">
          <div class="font-size22">{{ item.name }}</div>
          <div class="row-me row-center pointer" @click="clickEdit(item)" v-if="canOperate">
            <img src="../../assets/img/edit_blue.png" class="img18 margin-left20">
            <div class="blue-text margin-left5">编辑流程</div>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div class="row-me row-center" v-for="(item1,index1) in item.list" :key="index1">
            <div class="step-div">{{ item1 }}</div>
            <div class="margin-left10 margin-right10" style="color: #A6AAB8;" v-if="index1!==item.list.length-1">→</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog title="编辑流程" v-model="visible" width="600px" top="10vh" :destroy-on-close="true">
      <div class="padding-left20">
        <div class="font-size22 margin-bottom30">{{ selectItem.name }}</div>
        <div class="row-me row-center margin-bottom20" v-for="(item,index) in selectItem.list" :key="index">
          <div class="margin-right10">第{{ index + 1 }}步：</div>
          <div class="flex1">
            <el-select placeholder="请选择" style="width: 100%;" filterable clearable v-model="item.name"
                       :disabled="item.name==='接方'||item.name==='审方'||item.name==='调剂'"
                       @change="e=>nameChange(e,item,index)" @focus="e=>nameFocus(e,index)">
              <el-option v-for="item1 in showStepArray" :key="item1" :label="item1" :value="item1">
              </el-option>
            </el-select>
          </div>
          <img src="../../assets/img/jian.png" class="img24 pointer padding-left10"
               v-if="item.name!=='接方'&&item.name!=='审方'&&item.name!=='调剂'"
               @click="selectItem.list.splice(index,1)">
          <div v-else class="img24 padding-left10"></div>
        </div>
        <div class="row-me row-center">
          <div class="margin-right10">&emsp;&emsp;&emsp;&nbsp;&nbsp;</div>
          <div class="btn-add flex1" @click="clickAddStep">+ 添加流程</div>
          <div class="img24 padding-left10"></div>
        </div>
        <div class="row-me row-center flex-end1 margin-top55">
          <div class="btn-blank width110 btn-height40" @click="visible=false">取消</div>
          <div class="btn-blue width110 btn-height40 margin-left20" @click="clickSave">保存</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tableData: [],
      visible: false,
      detailItem: {},//接口返回数据
      selectItem: {},
      stepArray: ['复核', '泡药', '煎药', '包装'],
      showStepArray: [],
      canOperate: false,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    clickEdit(item) {
      this.selectItem = this.$method.deepClone(item)
      let arr = []
      for (let obj of item.list) {
        arr.push({
          name: obj
        })
      }
      this.selectItem.list = arr
      this.visible = true
    },
    //下拉聚焦触发，赋值不同的下拉
    nameFocus(e, index) {
      let name = this.selectItem.list[index - 1].name
      let pos = this.stepArray.indexOf(name)
      let arr = [];
      let stepArr = this.$method.deepClone(this.stepArray)
      if (pos === -1) {
        arr = stepArr
      } else {
        arr = stepArr.splice(pos + 1, stepArr.length)
      }
      this.showStepArray = arr
    },
    nameChange(e, item, index) {
      let arr = this.selectItem.list.filter(item => {
        return item.name === e
      })
      if (arr.length > 1) {
        item.name = ''
        this.$confirm("该流程已经存在，请选择其他流程", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
      } else {
        this.selectItem.list.splice(index + 1, this.selectItem.list.length - 1)
      }
    },
    //添加流程
    clickAddStep() {
      let a = this.selectItem.list.some(item => {
        return this.$method.isEmpty(item.name)
      })
      if (a) {
        this.$message.error('请填写完整才能添加')
        return
      }
      this.selectItem.list.push({
        name: ''
      })
    },
    //保存
    clickSave() {
      for (let i = 0; i < this.selectItem.list.length; i++) {
        let item = this.selectItem.list[i]
        if (this.$method.isEmpty(item.name)) {
          this.$confirm("第" + (i + 1) + "步尚未选择流程，请选择或者删除后再保存", "温馨提示", {
            confirmButtonText: "知道了",
            showCancelButton: false,
            type: "warning",
          }).then(() => {
          }).catch(() => {
          });
          return
        }
      }
      this.detailItem[this.selectItem.prop] = this.selectItem.list.map(item => {
        return item.name
      }).join(',')
      this.$postRequest('/admin/systemConfig/orderProcessUpdate', this.detailItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visible = false
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/systemConfig/orderProcessList', {}).then((res) => {
        if (res) {
          this.detailItem = res.data
          this.tableData = []
          this.tableData.push({
            name: '汤剂-代煎',
            prop: 'dj',
            list: res.data['dj'] ? res.data['dj'].split(',') : []
          })
          this.tableData.push({
            name: '汤剂-自煎',
            prop: 'zj',
            list: res.data['zj'] ? res.data['zj'].split(',') : []
          })
          this.tableData.push({
            name: '中医外治',
            prop: 'zywz',
            list: res.data['zywz'] ? res.data['zywz'].split(',') : []
          })
          this.tableData.push({
            name: '散剂',
            prop: 'sj',
            list: res.data['sj'] ? res.data['sj'].split(',') : []
          })
          this.tableData.push({
            name: '膏剂',
            prop: 'gj',
            list: res.data['gj'] ? res.data['gj'].split(',') : []
          })
          this.tableData.push({
            name: '颗粒剂',
            prop: 'klj',
            list: res.data['klj'] ? res.data['klj'].split(',') : []
          })
          this.tableData.push({
            name: '丸剂',
            prop: 'wj',
            list: res.data['wj'] ? res.data['wj'].split(',') : []
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.processConfig {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    overflow: auto;

    .item-div {
      padding: 25px 20px;
      border-bottom: 1px dashed #E5E9ED;

      .step-div {
        border: 1px solid #D4D7E0;
        border-radius: 4px;
        padding: 8px 30px;
        color: #181E2B;
      }
    }
  }

  .btn-add {
    border: 1px dashed #D4D7E0;
    border-radius: 4px;
    font-size: 18px;
    color: #181E2B;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    user-select: none;

    &:hover {
      border-color: #2d7ddf;
    }
  }
}
</style>
